import { render } from "./MessengerComponent.vue?vue&type=template&id=bc255abc&scoped=true"
import script from "./MessengerComponent.vue?vue&type=script&lang=js"
export * from "./MessengerComponent.vue?vue&type=script&lang=js"

import "./MessengerComponent.vue?vue&type=style&index=0&id=bc255abc&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc255abc"]])

export default __exports__